export const HEXON_DOMAIN = 'app/modules/HEXON/HEXON_DOMAIN';
export const FETCH_HEXON = 'app/modules/HEXON/FETCH_HEXON';
export const FETCH_HEXON_CONTROL_PANEL_URL = 'app/modules/HEXON/FETCH_HEXON_CONTROL_PANEL_URL';
